/* The Christmas Cart: Inspiration Gallery 2026 sections. Quiz, add to cart, starter kit. */
(function () {
  if (window.__tccInspo) return;
  window.__tccInspo = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Add items to the cart, then let the theme's cart drawer refresh and open.
  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-ajax' })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (json) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: json } }));
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        return cart;
      });
  }

  // Single product buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.tcc-add');
    if (!b || b.disabled) return;
    e.preventDefault();
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Adding\u2026';
    addToCart([{ id: +b.dataset.variant, quantity: 1 }])
      .then(function () { b.textContent = 'Added \u2713'; b.classList.add('is-added'); })
      .catch(function (err) { b.textContent = (err && err.description) || 'Sold out'; })
      .finally(function () { setTimeout(function () { b.disabled = false; b.textContent = label; b.classList.remove('is-added'); }, 2500); });
  });

  // Starter kit
  function initKit(kit) {
    var threshold = +kit.dataset.threshold * 100;
    var total = kit.querySelector('[data-kit-total]');
    var bar = kit.querySelector('[data-kit-bar]');
    var ship = kit.querySelector('[data-kit-ship]');
    var btn = kit.querySelector('[data-kit-add]');
    var msg = kit.querySelector('[data-kit-msg]');
    function boxes() { return kit.querySelectorAll('input[data-variant]:checked'); }
    function update() {
      var sum = 0;
      boxes().forEach(function (i) { sum += +i.dataset.line; });
      total.textContent = money(sum);
      bar.style.width = Math.min(100, threshold ? (sum / threshold) * 100 : 100) + '%';
      ship.innerHTML = sum >= threshold
        ? '<strong style="color:var(--tcc-ok)">\u2713 Free standard shipping unlocked</strong>'
        : 'Add ' + money(threshold - sum) + ' more for free shipping';
      btn.disabled = !boxes().length;
    }
    kit.addEventListener('change', update);
    btn.addEventListener('click', function () {
      var items = [];
      boxes().forEach(function (i) { items.push({ id: +i.dataset.variant, quantity: +i.dataset.qty }); });
      btn.disabled = true;
      msg.textContent = 'Adding your kit\u2026';
      addToCart(items)
        .then(function () { msg.textContent = 'Your kit is in the cart.'; })
        .catch(function (err) { msg.textContent = (err && err.description) || 'Something went wrong. Please try again.'; })
        .finally(function () { btn.disabled = false; });
    });
    update();
  }

  // Find-your-look quiz
  function initQuiz(quiz) {
    var trees = JSON.parse(quiz.querySelector('[data-quiz-trees]').textContent);
    var out = quiz.querySelector('[data-quiz-result]');
    function run() {
      var c = quiz.querySelector('input[name$="colour"]:checked');
      var f = quiz.querySelector('input[name$="feel"]:checked');
      if (!c || !f || !trees.length) return;
      var best = trees[0], bestScore = -1;
      trees.forEach(function (t) {
        var s = (t.colour === c.value ? 3 : 0) + (t.feel === f.value ? 2 : 0);
        if (s > bestScore) { best = t; bestScore = s; }
      });
      out.innerHTML = (best.img ? '<img src="' + best.img + '" alt="" width="96" height="96" loading="lazy">' : '<span></span>') +
        '<div><span class="tcc-muted" style="font-size:12px">Your match</span>' +
        '<strong class="tcc-h-sm" style="font-family:var(--tcc-display)"></strong>' +
        '<span style="font-size:13px"></span>' +
        '<a class="tcc-link" href="' + best.url + '"></a></div>';
      out.querySelector('strong').textContent = best.name;
      out.querySelector('div span:nth-of-type(2)').textContent = best.line;
      out.querySelector('a').textContent = 'Shop ' + best.name + ' \u2192';
    }
    quiz.addEventListener('change', run);
    run();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-tcc-kit]').forEach(initKit);
    (scope || document).querySelectorAll('[data-tcc-quiz]').forEach(initQuiz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-run when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
